<script lang="ts">
  import { TypographyType } from "../lib/constants/typographyMap";
  import Typography from "./Typography.svelte";

  export let text: string | undefined = undefined;
  export let showBorder = false;
  export let grayscale = false;
  export let color: "blue" | "purple" = "purple";
</script>

<Typography
  mobile={TypographyType.Body2Regular}
  desktop={TypographyType.Body2Medium}
  --font-color={`var(--color-${color}-50)`}>
  <div
    class:grayscale
    class:bordered={showBorder}
    class={`pill bg-[var(--color-purple-10)] w-fit rounded-3xl px-2`}
    class:blue={color === "blue"}>
    {text}
  </div>
</Typography>

<style>
  .pill {
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .pill.bordered {
    padding-top: 0;
    padding-bottom: 0;
    border: 1px solid var(--color-purple-50);
  }

  .blue {
    background-color: var(--color-blue-10);
    color: var(--color-blue-80);
  }
</style>
